import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import Select from "react-select"
import { get, post } from "helpers/api_helper"
import { PAYROLL_TDS_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const SalaryTDS = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [singleTds, setSingleTds] = useState([])
    const [marriedTds, setMarriedTds] = useState([])
    const [pagination, setPagination] = useState({ limit: 10, page: 1, search: "" })
    
    const [formData, setFormData] = useState({
        type: "Single",
        annual_salary_from: "",
        annual_salary_to: "",
        tds_percent: "",
        branch_id: "1"
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ type: "Single", annual_salary_from: "", annual_salary_to: "", tds_percent: "", branch_id: "1" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(PAYROLL_TDS_URL)
        if (res.status === 200) {
            const rows = res.response.rows || []
            setSingleTds(rows.filter(r => r.type === 'Single'))
            setMarriedTds(rows.filter(r => r.type === 'Married'))
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [pagination])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_TDS_URL}_update`, formData)
            : await post(PAYROLL_TDS_URL, formData)
            
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ ...row })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this TDS entry?")) {
            const res = await get(`${PAYROLL_TDS_URL}_delete?id=${id}`)
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "annual_salary_from", text: "ANNUAL SALARY FROM" },
        { dataField: "annual_salary_to", text: "ANNUAL SALARY TO" },
        { dataField: "tds_percent", text: "TDS(%)" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <div className="mb-4">
                <Datatables 
                    title="Salary TDS Detail For Single"
                    titleClass="h5"
                    columns={columns} 
                    rows={singleTds} 
                    keyField="id" 
                    isSearch={false} 
                    isAdd={true} 
                    btnTitle="Add Salary TDS"
                    btnColor="success"
                    handleAddButton={toggleModal}
                    loading={isLoading} 
                />
            </div>
            
            <Datatables 
                title="Salary TDS Detail For Married"
                titleClass="h5"
                columns={columns} 
                rows={marriedTds} 
                keyField="id" 
                isSearch={false} 
                isAdd={false} 
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} Salary TDS</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Type <span className="text-danger">*</span></Label>
                                    <Select 
                                        options={[{ label: "Single", value: "Single" }, { label: "Married", value: "Married" }]} 
                                        value={{ label: formData.type, value: formData.type }}
                                        onChange={(opt) => setFormData({ ...formData, type: opt.value })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>TDS(%) <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter TDS percentage" 
                                        value={formData.tds_percent}
                                        onChange={(e) => setFormData({ ...formData, tds_percent: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Annual Salary From <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter amount" 
                                        value={formData.annual_salary_from}
                                        onChange={(e) => setFormData({ ...formData, annual_salary_from: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Annual Salary To <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter amount" 
                                        value={formData.annual_salary_to}
                                        onChange={(e) => setFormData({ ...formData, annual_salary_to: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default SalaryTDS
